import React from 'react';

import { LoadingIndicator } from '@/ui/controls';

import { BookingManagementPageLayout } from '.';

interface BookingManagementPageLoadingLayoutProps {}

export const BookingManagementPageLoadingLayout: React.FC<
  BookingManagementPageLoadingLayoutProps
> = () => {
  return (
    <BookingManagementPageLayout>
      <LoadingIndicator style="dark" />
    </BookingManagementPageLayout>
  );
};
